(function () {
// Get all of the swipers on the page
    const allSliders = document.querySelectorAll('.land-slider');

// Loop over all of the fetched sliders and apply Swiper on each one.
    const swiper = new Swiper('.swiper', {
        // Optional parameters
        loop: true,

        // If we need pagination

        autoplay: {
            delay: 8000, // Delay between transitions in ms
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1024: {
                slidesPerView: 1,
                spaceBetween: 0,
                slideToClickedSlide: true,
            },
            1366: {
                slidesPerView: 2,
                spaceBetween: 0,
                slideToClickedSlide: true,
            }
        }
    });

    const swiper2 = new Swiper('.swiper2', {
        // Optional parameters
        slidesPerView: "auto",
        loop: 'true',
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        /*
                breakpoints: {
                    1024: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        slideToClickedSlide: true,
                    },
                    1366: {
                        slidesPerView: 2.5,
                        spaceBetween: 0,
                        slideToClickedSlide: true,
                    }
                }

       */
    });

    const videos = {
        'slide1': '/static/landings/sitnikov/vid/koop.mp4',
        'slide2': '/static/landings/sitnikov/vid/ziz.mp4',
        'slide3': '/static/landings/sitnikov/vid/3.mp4',
        'slide4': '/static/landings/sitnikov/vid/4.mp4',
        'slide5': '/static/landings/sitnikov/vid/5.mp4',
    }





    const app = document.querySelector('.app');

    // Делегирование событий для меню
    app.addEventListener('click', function (e) {
        const menu = document.querySelector('.hburger-menu');
        if (!menu) return;

        if (e.target.closest('.burger-icon')) {
            menu.classList.toggle('hidden');
            return;
        }

        if (e.target.closest('.hburger-menu-close') ||
            !e.target.closest('.hburger-document.cookiemenu')) {
            menu.classList.add('hidden');
        }
    });

    app.addEventListener('click', function(e) {
        const swiper = document.querySelector('.swiper2');
        if (!swiper) return;

        if (e.target.closest('.swiper-slide')) {
            const vidId = e.target.getAttribute('id');
            for (const key in videos) {
                if (vidId === key) {

                    var src = videos[key];

                    const iframe = document.createElement('div');
                    iframe.innerHTML = `
                        <video 
                            class="iframe-video2" 
                                    width = '250'  height = '475' controls
                                    autoplay="autoplay">
                             <source src="${src}" type="video/mp4">
                        </video>
                        <button class="iframe-close">&times;</button>
                        <div class="overlay"></div>`;

                    iframe.classList.add('iframe-video-wrap');



                    document.querySelector('.app__content').appendChild(iframe)

                    document.querySelector('.overlay')
                        ? document.querySelector('.overlay').addEventListener('click', function () {
                            document.querySelector('.app__content').removeChild(document.querySelector('.iframe-video-wrap'))
                        }) : window.console.log(iframe);
                    document.querySelector('.iframe-close').addEventListener('click', function () {
                        document.querySelector('.app__content').removeChild(document.querySelector('.iframe-video-wrap'))
                    })
                }
            }
        }



    });


    // Обработчики для dropdown
    document.querySelectorAll('.dropdown').forEach(elem => {
        elem.addEventListener('click', function(e) {
            this.classList.toggle('opened');
        });
    });



    let shorts = {
        'sitnikov': '/static/landings/sitnikov/vid/sitnikov.mp4',
        'akchurina': '/static/landings/_defaults/vid/akchurina.mp4',
        'evdokimov': '/static/landings/_defaults/vid/evdokimov.mov',
    }

    if (document.querySelector('.shorts')) {
        document.querySelectorAll('.shorts').forEach(el =>
            el.addEventListener('click', function (e) {
                if (e.target.classList.contains('swiper-slide')) {
                    const videoId = e.target.getAttribute('id');
                    for (const key in shorts) {
                        if (videoId === key) {

                            var src = shorts[key];

                            const iframe = document.createElement('div');
                            iframe.innerHTML = `
                        <video 
                            class="iframe-video" 
                                    width = '250'  height = '475' controls
                                    autoplay="autoplay">
                             <source src="${src}" type="video/mp4">
                        </video>
                        <button class="iframe-close">&times;</button>
                        <div class="overlay"></div>`;
                            iframe.classList.add('iframe-video-wrap');

                            document.querySelector('.app__content').appendChild(iframe)

                        }
                    }

                    document.querySelector('.overlay')
                        ? document.querySelector('.overlay').addEventListener('click', function () {
                            document.querySelector('.app__content').removeChild(document.querySelector('.iframe-video-wrap'))
                        }) : window.console.log(iframe);
                    document.querySelector('.iframe-close').addEventListener('click', function () {
                        document.querySelector('.app__content').removeChild(document.querySelector('.iframe-video-wrap'))
                    })
                }
            }))

    }



    if(document.querySelector('.ai-rodin')) {
        document.querySelector('.course-wrapper').style.marginTop = '80px';
        setTimeout(function () {
            document.querySelector('.popup').style.transform = 'translate(0, -100px)';
            document.querySelector('.popup').style.height = 0;
            document.querySelector('.popup').style.marginBottom = 0;
            document.querySelector('.course-wrapper').style.marginTop = 0;

        }, 20000)
    }

    var timeEl, timeDeadline, timeCurrent, elD, elH;

    var getTimeRemaining = function () {

        var t = timeDeadline - timeCurrent;

        var hours = Math.floor( (t/(1000*60*60)) % 24 );
        var days = Math.floor( t/(1000*60*60*24) );
        var minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
        return {
            'total': t,
            'days': days,
            'hours': hours,
            'minutes': minutes,
        };

    };

    var initClock = function (id, endtime){

        var timeinterval = setInterval(function(){

            timeDeadline = timeDeadline - 1000;

            var t = getTimeRemaining();

            elD.innerHTML = t.days +'&nbsp;';
            elH.innerHTML = ('0' + t.hours).slice(-2)+'&nbsp;';

            if(t.total <= 0) {
                clearInterval(timeinterval);
                document.querySelector('.yaconf-timer').innerHTML = 'Набор на курс'
                if(document.querySelector('.popup')) {
                    document.querySelector('.popup-timer').innerHTML = 'Набор на курс'
                }
                elD.innerHTML = '00';
                elH.innerHTML = '00';
                return
            }


            function declOfNum(number, titles) {
                var cases = [2, 0, 1, 1, 1, 2];
                return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
            }

            document.querySelector('#days').innerHTML =  declOfNum(t.days, ['день', 'дня', 'дней']);
            document.querySelector('#hours').innerHTML =  declOfNum(('0' + t.hours).slice(-2), ['час', 'часа', 'часов']);

            if(document.querySelector('.popup')) {
                document.querySelector('#days2').innerHTML =  t.days;
                document.querySelector('#hours2').innerHTML =  t.hours;
                document.querySelector('#min2').innerHTML =  t.minutes;
            }

        }, 1000);
    };

    var initBoomTimer = function(el) {

        timeEl = document.getElementById('boom_timer');

        if (!timeEl)
            return;

        elD = document.getElementById('boom_timer_d');
        elH = document.getElementById('boom_timer_h');


        timeDeadline = Date.parse('2026-03-09T09:00:00');

        timeCurrent = new Date();

        initClock();

    };

    initBoomTimer();

    var r = document.getElementById('reg');

    setInterval(function(){

        if(document.querySelector('.tochki')) {
            const colon2  = document.querySelector('.tochki');
            colon2.classList.toggle('tic');
        }
    }, 1000);
})();
